// js/util.js
// Shared pure helpers for the MARKETING pages (index/start/help). Loaded via the header/boot
// bundles. The authed app + its rich util surface (date/rate/money-input/relative-time/file-size)
// moved to the React client and the shared @northstar/* packages at the web flip; what remains here
// is only what the static pages actually call: HTML escaping + locale-aware money formatting.

// Escape a value for safe interpolation into an HTML string (used by header.js / start.boot.js).
function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, c =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

// Locale-aware money formatting. LOCALE follows the user's browser (a German user sees 1.234,56, an
// Irish user 1,234.56); CURRENCY follows the data. Pinning a locale anywhere is the drift this avoids.
function appLocale() {
  try { return (navigator.languages && navigator.languages[0]) || navigator.language || 'en-IE'; }
  catch (_) { return 'en-IE'; }
}
function formatMoney(value, currency = 'EUR', decimals = 0) {
  const n = Number(value || 0), cur = currency || 'EUR';
  try { return new Intl.NumberFormat(appLocale(), { style: 'currency', currency: cur, maximumFractionDigits: decimals }).format(n); }
  catch (_) {
    // Unknown currency code or no Intl — degrade to a grouped number with the code.
    try { return cur + ' ' + new Intl.NumberFormat(appLocale(), { maximumFractionDigits: decimals }).format(n); }
    catch (_) { return cur + ' ' + n.toFixed(decimals); }
  }
}

export { escapeHtml, appLocale, formatMoney };
